import { Delete, Edit } from "@mui/icons-material";
import { IconButton, ListItem } from "@mui/material";
import React, { ReactNode } from "react";

import { RoutePath } from "../../models/routePath";
import "./EditableItemList.scss";

interface EditableItemListItemProps {
  item: any;
  itemId: string;
  onEdit: (item: any) => void;
  onDelete: (id: string) => void;
  icon?: ReactNode;
}

const EditableItemListItem = (
  props: React.PropsWithChildren<EditableItemListItemProps>,
) => {
  const { item, itemId, children, onEdit, onDelete, icon } = props;

  const hideDeleteButton = window.location.pathname.includes(
    RoutePath.ConfirmQuantities,
  );

  return (
    <ListItem
      divider
      className="list-item"
      key={itemId}
      secondaryAction={
        <>
          <IconButton edge="end" aria-label="edit" onClick={() => onEdit(item)}>
            <Edit />
          </IconButton>
          {!hideDeleteButton ? (
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => onDelete(itemId)}
            >
              <Delete />
            </IconButton>
          ) : undefined}
        </>
      }
    >
      <>
        {icon}
        {children}
      </>
    </ListItem>
  );
};

export default EditableItemListItem;
